import { useState, useContext, useEffect } from "react";
import usePageName from "../../../hocs/usePageName";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import useTrimCatalog from "../../../hooks/useTrimCatalog";
import { Box } from "@mui/material";
import PrintCustomerCatalog from "../../../components/Catalog/PrintCatalog";

const CompanyStockCatalog = () => {
  usePageName({ heading: "Company Stock Trim Catalog" });
  const navigate = useNavigate();
  const { authToken, role, decoded } = useContext(AuthContext);
  const [
    searchQuery,
    setSearchQuery,
    catalogFilter,
    setCatalogFilter,
    results,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  ] = useTrimCatalog(authToken, 2000, null, "catalog");

  return (
    <Box sx={{ heght: "100%", display: "flex", flex: 1 }}>
      <PrintCustomerCatalog items={results} companyName={decoded.companyName} />
    </Box>
  );
};
export default CompanyStockCatalog;
